module.exports = __webpack_public_path__ + "img/mobileBackground2.b7702e26.png";